/* eslint-disable */
import * as React from 'react';
import { Box, Button, Grid, TextField } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

interface ZoneAdditionalTimeFormProps {
  cleaning_interval_seconds_override: number;
  next?: Function;
}

export const ZoneAdditionalTimeForm = React.forwardRef((props: ZoneAdditionalTimeFormProps, ref) => {
  const { cleaning_interval_seconds_override, next = () => {} } = props;

  const formManager = useFormik({
    initialValues: {
      cleaning_interval_seconds_override: cleaning_interval_seconds_override / 60,
    },
    validationSchema: Yup.object({
      cleaning_interval_seconds_override: Yup.number()
        .nullable()
        .required('This value is required.')
        .min(30, 'This value must be greater than 30 (mins).'),
    }),
    onSubmit: (values) => {
      const { cleaning_interval_seconds_override } = values;

      // TODO: Refactor dispatching old actions
      // dispatch(
      //   zonesAction.addAdditionalTime({
      //     cleaning_interval_seconds_override: cleaning_interval_seconds_override * 60,
      //     next,
      //   }),
      // );
    },
  });

  React.useImperativeHandle(
    ref,
    () => ({
      onSubmit() {
        formManager.handleSubmit();
      },
    }),
    [],
  );

  return (
    <form onSubmit={formManager.handleSubmit}>
      <Box paddingY={2}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="Additional minutes"
              variant="outlined"
              value={formManager.values.cleaning_interval_seconds_override || ''}
              onChange={formManager.handleChange('cleaning_interval_seconds_override')}
              error={
                !!(
                  formManager.errors.cleaning_interval_seconds_override &&
                  formManager.touched.cleaning_interval_seconds_override
                )
              }
              helperText={
                formManager.touched.cleaning_interval_seconds_override
                  ? formManager.errors.cleaning_interval_seconds_override
                  : null
              }
            />
          </Grid>

          <Grid item xs={12} hidden>
            <Button type="submit" variant="contained" fullWidth>
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
});
